module.exports = __webpack_public_path__ + "static/img/server1.e182528.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/server1.jpeg
// module id = bT1f
// module chunks = 1